/**
 * Custom Collapse Component
 * Extends Ant Design Collapse with custom styling
 */

import { Collapse as AntCollapse, CollapseProps } from 'antd';
import classNames from 'classnames';
import './CustomCollapse.scss';

export interface CustomCollapseProps extends CollapseProps {
  /** Collapse variant */
  variant?: 'default' | 'borderless' | 'ghost';
}

/**
 * CustomCollapse Component
 */
export const CustomCollapse: React.FC<CustomCollapseProps> = ({
  variant = 'default',
  className,
  ...rest
}) => {
  const collapseClasses = classNames('custom-collapse', `custom-collapse--${variant}`, className);

  return <AntCollapse {...rest} className={collapseClasses} />;
};

export const CustomCollapsePanel = AntCollapse.Panel;

export default CustomCollapse;

